/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mNav.vue?vue&type=template&id=5f320e4c&scoped=true"
import script from "./mNav.vue?vue&type=script&lang=js"
export * from "./mNav.vue?vue&type=script&lang=js"
import style0 from "./mNav.vue?vue&type=style&index=0&id=5f320e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f320e4c",
  null
  
)

export default component.exports